let toggles = document.querySelectorAll('[data-id="faq-toggle"]');
toggles.forEach((item) => {
    item.addEventListener('click', (event) => {
        let _this = event.target;
        let _parent;
        switch (_this.tagName.toLowerCase() === 'span') {
            case true:
                _this.parentNode.classList.toggle('open');
                _parent = _this.parentNode.parentNode;
                break;
            default:
                _this.classList.toggle('open');
                _parent = _this.parentNode;
                break;
        }
        let siblings = Array.prototype.filter.call(item.parentNode.parentNode.children, (sibling) => {
            return sibling !== _parent;
        });
        siblings.forEach((sibling) => {
            sibling.querySelector('[data-id="faq-toggle"]').classList.remove('open');
        });

        _this.scrollIntoView();
    })
})

function scrollIntoViewport(element) {
    const rect = element.getBoundingClientRect();
    if (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ){
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }
}
